<template>
  <v-container
    class="my-6"
  >
    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
      >
        <v-card>
          <v-card-title primary-title>
            <v-row
              class="text-center"
            >
              <v-col cols="12">
                <v-icon x-large class="blue--text text--darken-2">
                  mdi-at
                </v-icon>
              </v-col>
              <v-col cols="12">
                <div class="headline">
                  <span v-if="!newEmailSuccessMessage">Neue E-Mail-Adresse eingeben!</span>
                  <span v-else>Bestätigungsmail an Deine neue Adresse versendet.</span>
                </div>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row
              v-if="!newEmailSuccessMessage"
              justify="center"
            >
              <v-col
                cols="12"
                sm="10"
              >
                <p class="body-1">
                  Ablauf: <br>Du erhälst eine E-Mail mit einem Bestätigungslink an Deine neue E-Mail-Adresse. Diesen Link musst Du klicken, um die neue E-Mail-Adresse zu aktivieren!
                </p>
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  prepend-icon="mdi-security"
                  hint="Neue E-Mail-Adresse eingeben"
                  v-model="mEmail"
                  name="email"
                  label="Neue E-Mail-Adresse"
                  required
                  :rules="emailRules"
                  :error-messages="errorMessageEmail"
                  :type="'email'"
                />

                <v-text-field
                  prepend-icon="mdi-security"
                  hint="Neue E-Mail-Adresse eingeben"
                  v-model="mEmail2"
                  name="email2"
                  label="Neue E-Mail-Adresse wiederholen"
                  required
                  data-vv-as="email"
                  :rules="email2Rules"
                  :error-messages="errorMessageEmail2"
                  :type="'text'"
                />

                <v-text-field
                  prepend-icon="mdi-security"
                  hint="Passwort eingeben"
                  v-model="mPassword"
                  name="password"
                  label="Passwort eingeben"
                  required
                  :type="showPW ? 'password' : 'text'"
                  @click:append="() => (showPW = !showPW)"
                  :append-icon="showPW ? 'mdi-eye' : 'mdi-eye-off'"
                />

                <my-alert
                  v-if="this.$store.state.error"
                  type="error"
                  :error="this.$store.state.error"
                  :title="this.$store.state.errorTitle"
                />
              </v-col>
            </v-row>
            <v-row
              v-else
            >
              <p class="text-center title font-weight-regular">
                Deine E-Mail-Adresse wurde temporär gespeichert.<br>Um die neue E-Mail-Adresse nutzen zu können, klicke den Link in Deiner soeben verschickten Bestätigungsmail an.<br>Erst danach kannst Du dich mit Deiner neuen E-MAil-Adresse anmelden.
              </p>
            </v-row>
          </v-card-text>

          <v-card-actions
            v-show="!newEmailSuccessMessage"
          >
            <v-btn
              outlined
              large
              class="warning--text mx-auto"
              @click="cancelEmail()"
              :loading="this.$store.state.loading"
            >
              Abbrechen <v-icon right class="warning--text">
                mdi-cancel
              </v-icon>
            </v-btn>
            <v-btn
              outlined
              large
              class="primary--text mx-auto"
              @click.native.stop="saveEmail()"
              :loading="this.$store.state.loading"
            >
              neue E-Mail-Adresse speichern <v-icon right class="blue--text text--darken-2">
                mdi-send
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ROOT_LOADING } from '../../store/mutation-types'
const emailCheck = require('../../vendor/checkEmail')

export default {
  name: 'Newemail',
  metaInfo: {
    title: 'Neue E-Mail-Adresse'
  },
  data () {
    return {
      newEmailSuccessMessage: false,
      newEmailProcess: false,
      mEmail: '',
      mEmail2: '',
      emailRules: [],
      email2Rules: [],
      errorMessageEmail: [],
      errorMessageEmail2: [],
      mPassword: '',
      showPW: true
    }
  },
  methods: {
    validateAll: (email, email2) => {
      const ret = { status: true }

      if (email !== email2) {
        ret.email2 = true
        ret.status = false
      }

      if (!emailCheck(email)) {
        ret.email = true
        ret.status = false
      }

      return ret
    },
    cancelEmail: function () {
      this.newEmailSuccessMessage = false
      this.newEmailProcess = false
      this.mEmail = ''
      this.mEmail2 = ''
      this.$router.replace({ path: '/settings' })
    },
    saveEmail: async function () {
      this.$store.commit(ROOT_LOADING, true)
      const check = this.validateAll(this.mEmail, this.mEmail2)
      this.emailRules = []
      this.email2Rules = []
      this.errorMessageEmail = []
      this.errorMessageEmail2 = []

      if (!check.status) {
        // show errors
        this.newEmailProcess = false

        if (check.email) {
          this.emailRules = this.errorMessageEmail = ['Gültige E-Mail-Adress erforderlich']
        }

        if (check.email2) {
          this.email2Rules = this.errorMessageEmail2 = ['E-Mail-Adressen stimmen nicht überein']
        }
        this.$store.commit(ROOT_LOADING, false)
        return false
      }

      const newEmail = await this.$store.dispatch('managerStore/saveNewEmail', {
        email: this.mEmail,
        email2: this.mEmail2,
        password: this.mPassword
      })
      if (newEmail) {
        this.newEmailSuccessMessage = true
      }
    }
  },
  created () {
    // check if user is already logged in and then redirect to home
    if (this.$store.state.matchEvaluationInProgress) {
      this.$router.replace({ path: '/' })
    }
  }
}
</script>
